(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ecomativesby-collection-product"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ecomativesby-collection-product')) {
    class EcomativesbyCollectionProduct extends HTMLElement {
      connectedCallback() {
        this.handle = new URL(window.location.href).searchParams.get('ecomativesby')?.trim().toLowerCase();

        if (!this.handle) {
          return;
        }

        this.scope = this.closest('.shopify-section');

        if (!this.scope) {
          return;
        }

        this.onCollectionLinkClick = this.preserveParameterOnLink.bind(this);
        this.scope.addEventListener('click', this.onCollectionLinkClick, true);
        this.addParameterToForms();

        if (window.Shopify?.queryParams) {
          window.Shopify.queryParams.ecomativesby = this.handle;
        }

        this.observer = new MutationObserver(() => {
          this.addParameterToForms();
          this.restoreUrlParameter();

          if (!this.promoteWithoutDuplicates()) {
            this.loadProduct();
          }
        });
        this.observer.observe(this.scope, { childList: true, subtree: true });

        if (!this.promoteWithoutDuplicates()) {
          this.loadProduct();
        }
      }

      disconnectedCallback() {
        if (this.onCollectionLinkClick) {
          this.scope?.removeEventListener('click', this.onCollectionLinkClick, true);
        }

        this.observer?.disconnect();
      }

      productListing() {
        return this.scope.querySelector('ul.productListing#main-collection-product-grid, .productListing.express-order-content');
      }

      addParameterToForms() {
        this.scope.querySelectorAll('collection-filters-form form').forEach((form) => {
          let input = form.querySelector('input[name="ecomativesby"]');

          if (!input) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'ecomativesby';
            form.append(input);
          }

          input.value = this.handle;
        });
      }

      preserveParameterOnLink(event) {
        const link = event.target.closest('.js-facet-remove, .pagination-wrapper a, a[data-load-more-product]');

        if (!link || !this.scope.contains(link)) {
          return;
        }

        const url = new URL(link.href, window.location.origin);
        url.searchParams.set('ecomativesby', this.handle);
        link.href = url.toString();

        if (link.dataset.href) {
          const dataUrl = new URL(link.dataset.href, window.location.origin);
          dataUrl.searchParams.set('ecomativesby', this.handle);
          link.dataset.href = dataUrl.toString();
        }
      }

      restoreUrlParameter() {
        const url = new URL(window.location.href);

        if (url.searchParams.get('ecomativesby') !== this.handle) {
          url.searchParams.set('ecomativesby', this.handle);
          history.replaceState(history.state, '', url.toString());
        }
      }

      handleFromCard(card) {
        if (card.dataset.ecomativesbyHandle) {
          return card.dataset.ecomativesbyHandle.toLowerCase();
        }

        const productLink = card.querySelector('a.card-link[href*="/products/"], a.product-grid-image[href*="/products/"], a[href*="/products/"]');

        if (!productLink) {
          return '';
        }

        const productPath = new URL(productLink.href, window.location.origin).pathname.split('/products/')[1];
        return decodeURIComponent(productPath?.split('/')[0] || '').toLowerCase();
      }

      matchingCards(listing) {
        return Array.from(listing.children).filter((card) => {
          return card.matches('.product:not(.banner)') && this.handleFromCard(card) === this.handle;
        });
      }

      promoteWithoutDuplicates() {
        const listing = this.productListing();

        if (!listing) {
          return false;
        }

        const matches = this.matchingCards(listing);

        if (matches.length === 0) {
          return false;
        }

        const promotedCard = matches.find((card) => card.hasAttribute('data-ecomativesby-promoted')) || matches[0];
        let changed = false;

        promotedCard.dataset.ecomativesbyHandle = this.handle;
        promotedCard.setAttribute('data-ecomativesby-promoted', '');

        matches.forEach((card) => {
          if (card !== promotedCard) {
            card.remove();
            changed = true;
          }
        });

        if (listing.firstElementChild !== promotedCard) {
          listing.prepend(promotedCard);
          changed = true;
        }

        if (changed) {
          window.sharedFunctions?.swapHoverVideoProductCard();
        }

        return true;
      }

      async loadProduct() {
        if (this.loadingProduct || !this.productListing()) {
          return;
        }

        this.loadingProduct = true;

        try {
          const collectionUrl = this.dataset.collectionUrl || window.Shopify.routes.root;
          const productUrl = new URL(`${collectionUrl.replace(/\/$/, '')}/products/${encodeURIComponent(this.handle)}`, window.location.origin);
          productUrl.searchParams.set('section_id', 'ecomativesby-product');

          const response = await fetch(productUrl.toString());

          if (!response.ok || !this.isConnected || this.promoteWithoutDuplicates()) {
            return;
          }

          const responseDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
          const listing = this.productListing();
          const selector = listing?.matches('.express-order-content')
            ? 'template[data-card-layout="express"]'
            : 'template[data-card-layout="grid"]';
          const productCard = responseDocument.querySelector(selector)?.content.firstElementChild;

          if (!productCard || !listing || this.handleFromCard(productCard) !== this.handle) {
            return;
          }

          if (listing.classList.contains('halo-row--masonry')) {
            productCard.classList.add('product-masonry-item');
          }

          productCard.dataset.ecomativesbyHandle = this.handle;
          productCard.setAttribute('data-ecomativesby-promoted', '');
          listing.prepend(document.importNode(productCard, true));
          this.promoteWithoutDuplicates();
        } catch (error) {
          return;
        } finally {
          this.loadingProduct = false;
        }
      }
    }

    customElements.define('ecomativesby-collection-product', EcomativesbyCollectionProduct);
  }
  } catch(e) { console.error(e); }
})();

})();
